// extracted by mini-css-extract-plugin
export default {"callToWork":"CalToWork_callToWork__vOyMU","callToWork__title":"CalToWork_callToWork__title__VToMO","callToWork__link":"CalToWork_callToWork__link__QFlJ6"};